export var TextTrackModes;!function(e){e.DISABLED="disabled",e.HIDDEN="hidden",e.SHOWING="showing"}(TextTrackModes||(TextTrackModes={}));